import { ParsedUrlQuery } from 'querystring'

import { useRouter } from 'next/router'

import { isBrowser } from '../../utils'

// NextJS has cases where it flips back and forth on a query value before settling. Maybe this has to do with something
// we are causing, but I can't figure out what. So this stabalizes the value, only showing the final state query param.
function stabalizeQueryWithBrowserData(
  unstableNextJsQueryParams: ParsedUrlQuery,
  nextJsPathnameWithSlugs: string
) {
  const queryParams: Record<string, string | string[] | undefined> = {
    ...unstableNextJsQueryParams,
  }
  if (isBrowser()) {
    const browserQueryParams = new URLSearchParams(window.location.search)

    // Remove items not in the browser state
    Object.keys(queryParams).forEach(nextJsParamKey => {
      if (!nextJsPathnameWithSlugs.includes(`[${nextJsParamKey}]`)) {
        // If it is not a path param, we can sanitize it based on browser URL
        const browserQueryParamValue = browserQueryParams.get(nextJsParamKey)
        if (typeof browserQueryParamValue === 'undefined') {
          delete queryParams[nextJsParamKey]
        }
      }
    })

    // Pull in values from browser state
    browserQueryParams.forEach((val, key) => {
      if (typeof val === 'undefined') {
        delete queryParams[key]
      } else {
        queryParams[key] = val as string
      }
    })
  }

  return queryParams
}

export function useUpdateQueryParam() {
  const { updateQueryParams } = usePagesDirectoryStableQueryParams()
  return (key: string, value: string | undefined) => {
    return updateQueryParams({ [key]: value })
  }
}

export function usePagesDirectoryStableQueryParams() {
  const { query: unstableRouterQuery, replace, pathname: pathnameWithSlugs } = useRouter()
  const stabalizedQuery = stabalizeQueryWithBrowserData(unstableRouterQuery, pathnameWithSlugs)

  const updateQueryParams = (updatedQueryParams: Record<string, string | undefined>) => {
    const updatedQuery = { ...stabalizedQuery }

    Object.entries(updatedQueryParams).forEach(([key, val]) => {
      if (typeof val === 'undefined') {
        delete updatedQuery[key]
      } else {
        updatedQuery[key] = val as string
      }
    })

    replace(
      {
        query: updatedQuery,
      },
      undefined,
      { scroll: false, shallow: true }
    )
  }

  return {
    query: stabalizedQuery,
    updateQueryParams,
  }
}
